import React, { useRef } from 'react';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';

import { Line } from 'react-chartjs-2';

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
);

const getData = (sensores) => {

    const temperatura = sensores.map(item => item.temperatura);
    const humedad = sensores.map(item => item.humedad);
    const salinidad = sensores.map(item => item.salinidad);
    const hora = sensores.map(item => item.fecha);
    const conductividad = sensores.map(item => item.conductividad);
    const humedadAire = sensores.map(item => item.humedadAire);

    return {
        labels: hora,
        datasets: [
            {
                label: 'Temperature',
                data: temperatura,
                borderColor: 'rgb(220, 20, 60)',
                backgroundColor: 'rgba(220, 20, 60, 0.5)',
            },
            {
                label: 'Humidity',
                data: humedad,
                borderColor: 'rgb(65, 105, 225)',
                backgroundColor: 'rgba(65, 105, 225, 0.5)',
            },
            {
                label: 'Salinity',
                data: salinidad,
                borderColor: 'rgb(255, 255, 0)',
                backgroundColor: 'rgba(255, 255, 0, 0.5)',
            },
            {
                label: 'Conductivity',
                data: conductividad,
                borderColor: 'rgb(255, 125, 125)',
                backgroundColor: 'rgba(255, 125, 125, 0.5)',
            },
            {
                label: 'Air humidity',
                data: humedadAire,
                borderColor: 'rgb(0, 255, 0)',
                backgroundColor: 'rgba(0, 255, 0, 0.5)',
            }
        ],
    };
};

const getOptions = () => {
    return {
        responsive: true,
        interaction: {
            mode: 'index',
            intersect: false,
        },
        plugins: {
            legend: {
                position: 'top',
            },
            title: {
                display: true,
                text: 'Relation ground node',
            },
        },
    };
};

const ChartSuelo = ({ data, chartId }) => {
    const chartRef = useRef(null);
    return (
        <Line
            id={`chart-${chartId}`}
            key={chartId}
            ref={chartRef}
            options={getOptions()}
            data={getData(data)}
        />
    );
};

export default ChartSuelo;
